export const FETCH_APPLICATION = 'FETCH_APPLICATION';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_ERROR = 'FETCH_APPLICATION_ERROR';

// DMT LOCATION
export const FETCH_LOCATION = 'FETCH_LOCATION';
export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS';
export const FETCH_LOCATION_ERROR = 'FETCH_LOCATION_ERROR';

// fetch Slota
export const FETCH_SLOT = 'FETCH_SLOT';
export const FETCH_SLOT_SUCCESS = 'FETCH_SLOT_SUCCESS';
export const FETCH_SLOT_ERROR = 'FETCH_SLOT_ERROR';
// booking Apppointment
export const BOOKING_APPOINTMENT = 'BOOKING_APPOINTMENT';
export const BOOKING_APPOINTMENT_SUCCESS = 'BOOKING_APPOINTMENT_SUCCESS';
export const BOOKING_APPOINTMENT_ERROR = 'BOOKING_APPOINTMENT_ERROR';

export const FETCH_SELL_WORKFLOW_HISTORY = 'FETCH_SELL_WORKFLOW_HISTORY';
export const FETCH_SELL_WORKFLOW_HISTORY_SUCCESS = 'FETCH_SELL_WORKFLOW_HISTORY_SUCCESS';

export const SELL_CANCEL_APPLICATION = 'SELL_CANCEL_APPLICATION';
export const SELL_CANCEL_APPLICATION_SUCCESS = 'SELL_CANCEL_APPLICATION_SUCCESS';
export const SELL_CANCEL_APPLICATION_ERROR = 'SELL_CANCEL_APPLICATION_ERROR';

export const SELL_DOWNLOAD_TITLE_DEED = 'SELL_DOWNLOAD_TITLE_DEED';
export const SELL_DOWNLOAD_TITLE_DEED_SUCCESS = 'SELL_DOWNLOAD_TITLE_DEED_SUCCESS';
export const SELL_DOWNLOAD_TITLE_DEED_ERROR = 'SELL_DOWNLOAD_TITLE_DEED_ERROR';
